import { retry } from './retry';

/*
 * @Author: Nora Galvin
 * @Date: 2020-08-15 09:19:47
 * @Last Modified by: Hung Dinh
 * @Last Modified time: 2021-01-13 12:27:17
 */
declare let ace: any;

declare const window: any;

/**
 * Regex get file extension from source
 * @param src string
 * @returns string extension file
 */
export const getFileExtensionFromSource = (src: string): string | undefined => {
  if (!src.includes('.')) return undefined;
  const lastItem = src.split('.').pop();
  if (!lastItem) return undefined;

  const extension = lastItem.split('?').shift();
  return extension;
};

/**
 * Function check a string is url
 * @param src string
 * @returns boolean
 */
export const isURL = (src: string): boolean => {
  const pattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
  const matches = src.match(pattern);
  if (matches && matches[0]) {
    return true;
  }
  return false;
};

/**
 * Convert string to label
 * @param sentence ..
 * @returns return lable
 */
export const titleize = (sentence: string): string => {
  if (!sentence.split) return sentence;
  /**
   * ..
   * @param string ..
   * @returns strings
   */
  const _titleizeWord = function (string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };
  const result = Array<string>();
  sentence.split(/-|_| /).forEach(function (w) {
    result.push(_titleizeWord(w));
  });
  return result.join(' ');
};

/**
 * abc-xyz-ghi to abcXyzGhi
 * @param str ..
 * @returns string
 */
export const camelize = (str: string): string => {
  return str.toLowerCase().replace(/-[a-zA-Z]/g, (s: string) => s.replace('-', '').toUpperCase());
};

/**
 * Transform from atom ID to contentBk ID
 * @param atomID ..
 * @returns string
 */
export const atomIDToBkID = (atomID: string): string | undefined => {
  const arr = atomID.split('-');
  if (arr && arr.length) {
    const atomType = arr[0];
    arr.splice(0, 1);
    const atomID = arr.join('-');
    if (atomType == 'e') return 'element-' + atomID;
    if (atomType == 'm') return 'module-' + atomID;
    if (atomType == 'r') return 'row-' + atomID;
  }
};

/**
 * Show Notify
 * @param msg message
 * @param type type
 * @param duration duration
 * @returns void
 */
export const showNotify = (msg: string, type: string, duration?: string): void => {
  const $notifiBar = jQuery('#notifiBar');
  if (duration != undefined) {
    $notifiBar.data('notifibar').showNotifi({
      msg: msg,
      type: type,
      duration: duration,
    });
  } else {
    $notifiBar.data('notifibar').showNotifi({
      msg: msg,
      type: type,
    });
  }
};

/**
 * get ace editor mode from type
 * @param type type of code
 * @returns {String} mode
 */
export const getAceMode = (type: string): string => {
  switch ((type || '').toLowerCase()) {
    case 'template':
      return 'ace/mode/html';
    case 'style':
      return 'ace/mode/css';
    case 'script':
      return 'ace/mode/javascript';
    case 'data':
      return 'ace/mode/json';
  }
  return '';
};

/**
 * Init ace editor
 * @param {String} id element id
 * @param {String} tab code type
 * @param {String} mode mode to apply to editor
 * @returns {unknown} editor
 */
export const initAce = (id: string, tab = '', mode = ''): unknown => {
  if (!id || id == '') {
    return null;
  }

  const $el = ace.edit(id);
  $el.setTheme('ace/theme/monokai');
  $el.setAutoScrollEditorIntoView(true);
  $el.getSession().setTabSize(2);
  $el.getSession().setUseWrapMode(true);
  $el.setHighlightActiveLine(false);
  $el.setOption('maxLines', 27);
  $el.setOption('minLines', 27);
  if (!mode || mode == '') {
    $el.session.setMode(getAceMode(tab));
  } else {
    $el.session.setMode(mode);
  }
  if (tab && tab != '') {
    $el.container.id = id + 'Editor';
    jQuery($el.container).attr('gf-tab-content', tab);
  }
  return $el;
};

/**
 * get Rotate Deg value
 * @param $el DOM of element
 * @returns info {rad,deg} isCopied
 */
export const getRotationInfo = ($el: JQuery): any => {
  const tr =
      $el.css('-webkit-transform') ||
      $el.css('-moz-transform') ||
      $el.css('-ms-transform') ||
      $el.css('-o-transform') ||
      '',
    info = { rad: 0, deg: 0 };
  const trRegex = tr.match('matrix\\((.*)\\)');
  if (trRegex) {
    const trValue = trRegex[1].split(',') || [];
    if (typeof trValue[0] != 'undefined' && typeof trValue[1] != 'undefined') {
      info.rad = Math.atan2(parseFloat(trValue[1]), parseFloat(trValue[0]));
      info.deg = parseFloat(((info.rad * 180) / Math.PI).toFixed(1));
    }
  }
  return info;
};

/**
 * Copy a text string to clipboard
 * @param {String} text text to copy
 * @returns {Boolean} isCopied
 */
export const copyToClipboard = (text: string): boolean => {
  const _$input = document.createElement('input');
  _$input.value = text;
  document.body.appendChild(_$input);
  _$input.focus();
  _$input.select();
  try {
    document.execCommand('copy');
    // on success
    return true;
  } catch (error) {
    // on fail
    document.body.removeChild(_$input);
    return false;
  }
};

/**
 * Get Currency from children of Product module
 * @param $element JQuery Dom
 * @returns Currency : string
 */
export const getCurrency = ($element: JQuery): string => {
  let $product = $element.closest('[data-label="Product"]');
  if ($product.length == 0) {
    $product = $element.closest('[data-icon="gpicon-product"]');
  }
  let money = '${{ amount }}';
  const priceHolderRegex = /{{.+}}/i;
  if (window.parent) {
    try {
      const dataMoney = (window.parent as any).jQuery('#gfFrame').attr('data-money');
      const matchStr = new RegExp('>(.*)<');
      money = dataMoney.match(matchStr) ? dataMoney.match(matchStr)[1] : dataMoney;
    } catch (e) {
      /* eslint no-console: ["error", { allow: ["warn","log"] }] */
      console.log('fail to get data-money from DOM', e);
    }
  }
  const moneyFormat = $product.find('.gf_product-prices').attr('data-oldformat') || money;
  let priceValue = '0';
  if ($product.length > 0) {
    const $pPriceModule = $product.find('[data-label="(P) Price"]');
    if ($pPriceModule.length > 0) {
      priceValue = $pPriceModule.find('.gf_product-price').attr('data-price') || '0';
    }
  }
  const displayRegx = moneyFormat.replace(priceHolderRegex, priceValue);
  const matchedStringPrice = new RegExp('([^0-9.,])()([^0-9.,]*)', 'ig');
  const arr = displayRegx.match(matchedStringPrice);
  let currency = '';
  if (arr && arr.length > 0) {
    currency = arr[0];
  }
  return currency;
};
/**
 * get width element as percentage
 * @param $el DOM of element
 * @returns percentage number
 */
export const getWidthPercentage = ($el: JQuery): number => {
  let percent = $el.width() || 0;
  if ($el.length > 0) {
    const $parent = $el.parent();
    const widthStr: string = $el.css('width') || '';
    const width = parseFloat(widthStr);
    const parentWidthStr = $parent.css('width') || '';
    const parentWidth = parseFloat(parentWidthStr);
    if (parentWidth && parentWidth !== 0) {
      percent = (width / parentWidth) * 100;
    }
  }
  return !isNaN(percent) ? Math.round(percent) : percent;
};

/**
 * updateDynamicProduct in window._productDynamic
 * @param productJSON ..
 * @returns void
 */
export const updateDynamicProduct = (productJSON: any): void => {
  let pJSON: any = {};
  try {
    pJSON = JSON.parse(JSON.stringify(productJSON));
    if (pJSON.id == 'auto') {
      pJSON.id = pJSON.real_id;
    }
  } catch (error) {
    pJSON = {};
  }
  window._productDynamic = pJSON;
};

/**
 * convertProductFormHtmlToLiquid
 * @param html string
 * @param formId string
 * @param formClass string
 * @returns string
 */
export const convertProductFormHtmlToLiquid = function (html: string, formId = '', formClass = '') {
  let tmpHtml = html;

  const regex = '<form(.*?>)';
  if (tmpHtml.match(regex)) {
    const matcheds = tmpHtml.match(regex);
    if (matcheds && matcheds[0]) {
      const matched = matcheds[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const matchedString = new RegExp(matched, 'g');

      tmpHtml = tmpHtml.replace(
        matchedString,
        "{% unless product.empty?  %}{% form 'product', product, id: \"" +
          formId +
          '", class: "' +
          formClass +
          '", data-productid: product.id %}',
      );
      tmpHtml = tmpHtml.replace('</form>', '{% endform %}{% endunless %}');
    }
  }

  return tmpHtml;
};

/**
 * getFieldsFromObject
 * @param fieldsString is a string, split by ',' or space
 * @param object is an object
 * @returns void
 */
export const getFieldsFromObject = (fieldsString: string, object: any): any => {
  /**
   * TODO:
   * input is: "a, b, c"
   * I want to support alias like this: "a, b, customAlias:c"
   * => output: {a: 1, b: 2, customAlias: 3}
   */
  const fields = fieldsString.split(/[\s,]+/);
  const obj = {};
  fields.forEach((field) => {
    (obj as any)[field] = object[field];
  });
  return obj;
};

/**
 * getDynamicProduct in window._productDynamic
 * @param fields ..
 * @returns any
 */
export const getDynamicProduct = (fields?: string): any => {
  if (fields) {
    return getFieldsFromObject(fields, window._productDynamic);
  }
  return window._productDynamic;
};

/**
 * placeCaretAtEnd
 * @param $el .
 */
export const placeCaretAtEnd = ($el: JQuery): void => {
  $el.each(function () {
    jQuery(this).focus();
    const val = jQuery(this).val();
    // If this function exists...
    if ((this as any).setSelectionRange) {
      const valLen = val != undefined ? val.toString().length * 2 : 2;
      setTimeout(() => {
        (this as any).setSelectionRange(valLen, valLen);
      }, 16);
    } else {
      // ... otherwise replace the contents with itself
      // (Doesn't work in Google Chrome)
      $(this).val(val || '');
    }

    // Scroll to the bottom, in case we're in a tall textarea
    // (Necessary for Firefox and Google Chrome)
    this.scrollTop = 999999;
    this.scrollLeft = 999999;
  });
};

/**
 * listForms
 * @returns all form of Gempages
 */
export const listForms = [
  'Product',
  'Product List',
  'Related Products',
  'Mailchimp',
  'Contact Form',
  'Newsletter',
  'Firepush SMS Subscribers',
];

/**
 * listParentAtoms
 * @returns all parent atoms of Gempages
 */
export const listParentAtoms = ['Product', 'Product List', 'Related Products', 'Article List'];

/**
 * listChildProductAtoms
 * @returns all child atoms of Gempages
 */
export const listChildProductAtoms = [
  '(P) Title',
  '(P) Vendor',
  '(P) SKU',
  '(P) Price',
  '(P) Quantity',
  '(P) Image',
  '(P) Image List',
  '(P) Ali Reviews',
  '(P) Stock Counter',
  '(P) Cart Button',
  '(P) Dynamic Checkout Button',
  '(P) View More',
  '(P) Description',
  '(P) Variants',
  '(P) Swatches',
  '(P) Meta',
  'Infinite Options',
  'Recharge Subscription',
  'Bold Subscriptions',
  'Bold Product Options',
];

/**
 * listChildArticleAtoms
 * @returns all child atoms of Gempages
 */
export const listChildArticleAtoms = ['(A) Title', '(A) Image', '(A) Content', '(A) Excerpt', '(A) Date'];

/**
 * listChildArticleAtoms
 * @returns all child atoms of Gempages
 */
export const listChildAtoms = [...listChildProductAtoms, ...listChildArticleAtoms];

/**
 * Cắt bỏ phần url() khỏi url lấy từ css
 * @param url url to be trim
 * @returns {String} trimmed url
 */
export const trimUrlCss = (url: string): string => {
  try {
    return url.replace('url(', '').replace(')', '').replace(/"/g, '');
  } catch (error) {
    return url;
  }
};

/**
 * initSizeForElement
 * @param $elm :any
 * @param $target :string
 */
export const initSizeForElement = ($elm: any, $target: string) => {
  const listImg = $elm.find($target);
  if (listImg.length > 0) {
    jQuery.map(listImg, function (value) {
      jQuery(value).on('load', function (e) {
        if (e.target.naturalWidth && e.target.naturalHeight) {
          $(this).attr('width', e.target.naturalWidth);
          $(this).attr('height', e.target.naturalHeight);
        }
      });
    });
  }
  return;
};

interface imageData {
  width: number;
  height: number;
}
/**
 * Lấy width height gốc của ảnh
 * Load image trên DOM ảo để lấy được data. (không lo việc bị load 2 lần vì trình duyệt đã cache)
 * @param src source ảnh
 * @returns data có width height
 */
export const getNaturalSizeImage = (src: string): Promise<imageData> => {
  return new Promise<imageData>((resolve, reject) => {
    const img = new Image();
    /**
     * lắng nghe onload để lấy width height
     */
    img.onload = function () {
      const data = {
        width: (this as any).width,
        height: (this as any).height,
      };
      resolve(data);
    };
    img.onerror = reject;
    img.src = src;
  });
};

/**
 * Chuyển định dạng của field sang map cho nó dễ lấy dữ liệu
 * @param fields setting fields
 * @returns map setting fields
 */
export const convertFieldsToMapFields = (fields: any): Map<string, any> => {
  const map = new Map<string, any>();
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];
    if (!field) continue;

    //nomarl field
    if (field.type != 'group') {
      if (field.id) {
        map.set(field.id, field);
      }
    }

    //group
    if (field.type == 'group' && field.items && field.items.length > 0) {
      for (let h = 0; h < field.items.length; h++) {
        if (field.items[h].id) {
          map.set(field.items[h].id, field.items[h]);
        }
      }
    }

    //advanced
    if (field.advanced && field.advanced.length > 0) {
      for (let h = 0; h < field.advanced.length; h++) {
        if (field.advanced[h].id) {
          map.set(field.advanced[h].id, field.advanced[h]);
        }
      }
    }
  }
  return map;
};
/**
 * Lấy nhiều giá trị trong setting fields cùng 1 lần
 * @param fieldKeys list key cần lấy giá trị
 * @param fields fields lấy từ setting
 * @returns map values
 */
export const getValuesInFields = (fieldKeys: Array<string>, fields: any): Map<string, any> => {
  const map = new Map<string, any>();
  const mapFields = convertFieldsToMapFields(fields);

  for (let i = 0; i < fieldKeys.length; i++) {
    const fieldItem = mapFields.get(fieldKeys[i]);
    const valueItem = fieldItem && fieldItem.default_value ? fieldItem.default_value : '';
    map.set(fieldKeys[i], valueItem);
  }

  return map;
};

/**
 * setValuesToFields
 * @param newValues map data
 * @param fields fields lấy từ setting
 * @returns new fields
 */
export const setValuesToFields = (newValues: Map<string, any>, fields: any): any => {
  const mapKeys = Array.from(newValues.keys());
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];

    //nomarl field
    if (field.type != 'group') {
      if (mapKeys.indexOf(field.id) != -1) {
        field['default_value'] = newValues.get(field.id);
      }
    }

    //group
    if (field.type == 'group' && field.items && field.items.length > 0) {
      for (let h = 0; h < field.items.length; h++) {
        if (mapKeys.indexOf(field.items[h].id) != -1) {
          field.items[h]['default_value'] = newValues.get(field.items[h].id);
        }
      }
    }

    //advanced
    if (field.advanced != undefined && field.advanced && field.advanced.length > 0) {
      for (let h = 0; h < field.advanced.length; h++) {
        if (mapKeys.indexOf(field.advanced[h].id) != -1) {
          field.advanced[h]['default_value'] = newValues.get(field.advanced[h].id);
        }
      }
    }
  }
  return fields;
};

/**
 * Thêm script bị blocked
 * Trường hợp bị cookieyes chặn cần lưu lại những script bị block
 * @param url string
 */
export const addBlockedScript = function (url: string) {
  if (!window._pageLibsBlocked || !Array.isArray(window._pageLibsBlocked)) {
    window._pageLibsBlocked = [];
  }
  if (window._pageLibsBlocked.indexOf(url) === -1) {
    window._pageLibsBlocked.push(url);
  }
};

/**
 * Kiểm tra có phải blocked script bị chặn bởi cookieyes không
 * @param url string
 * @returns boolean
 */
export const isBlockedScript = function (url: string): boolean {
  if (window._pageLibsBlocked.indexOf(url) === -1) {
    return false;
  }
  return true;
};

/**
 * replace ký tự quote
 * " bằng &quot;
 * ' bằng &apos;
 */
export const replaceQuoteCharacter = function (str: string): string {
  return str.replace(/"/g, '&quot;').replace(/'/g, '&apos;');
};

/**
 * Phân biệt template và page
 * Home, Collection, Product là template trả về true
 * Sub Page, Article là page trả về false
 */
export const isTypeTemplate = function (pageType: string): boolean {
  if (['template-page', 'template-article'].includes(pageType)) {
    return false;
  }
  return true;
};

/**
 * getBoxShadowValue
 * @param $el :JQuery
 * @returns returnVal :any
 */
export const getBoxShadowValue = function ($el: JQuery): any {
  let value = '';
  value = $el.css('box-shadow');
  let returnVal = { color: '', y: '', x: '', blur: '', spread: '' };
  if (value != undefined) {
    // shadowVal = "rgb(0, 0, 0) 0px 1px 2px 3px"
    // color = 0
    // x = 1
    // y = 2
    // blur = 3
    // spread = 4
    const shadowVal = value.match(/-?(\d)+\.(\d+px)|(-?\d+px)|(rgb\(.+\))|(rgba\(.+\))/g);
    if (shadowVal != undefined && shadowVal.length > 0) {
      const color = shadowVal[0];
      const y = shadowVal[1];
      const x = shadowVal[2];
      const blur = shadowVal[3];
      const spread = shadowVal[4];
      returnVal = {
        color: color,
        y: y,
        x: x,
        blur: blur,
        spread: spread,
      };
    }
  }
  return returnVal;
};

/**
 * formatCSS
 * @param css :string
 * @param compress
 * @returns css :string
 */
export const formatCSS = function (css: string, compress = false) {
  if (!css) {
    return css;
  }
  css = css
    .replace(/\/\*(.*)\*\/|\n/g, '')
    .replace(/\t/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\s\{|\{\s/g, '{')
    .replace(/\}\s|\s\}/g, '}')
    .replace(/;\s|\s;/g, ';')
    .replace('undefined', '')
    .trim();

  if (compress === true) {
    return css;
  }
  const tabs = ['', '\t', '\t\t', '\t\t\t', '\t\t\t\t', '\t\t\t\t\t', '\t\t\t\t\t\t'];
  let num = 0;
  let len = css.length;
  for (let i = 0; i < len; i++) {
    if (css[i] == '{') {
      num++;
      if (css[i + 1] == '}') {
        css = css.slice(0, i + 1) + '\n' + tabs[num - 1] + css.slice(i + 1);
        len += num;
        i += num - 1;
      } else {
        css = css.slice(0, i + 1) + '\n' + tabs[num] + css.slice(i + 1);
        len += num + 1;
        i += num;
      }
    } else if (css[i] == '}') {
      num--;
      if (css[i + 1] == '}') {
        css = css.slice(0, i + 1) + '\n' + tabs[num - 1] + css.slice(i + 1);
        len += num;
        i += num - 1;
      } else {
        css = css.slice(0, i + 1) + '\n' + tabs[num] + css.slice(i + 1);
        len += num + 1;
        i += num;
      }
    } else if (css[i] == ';') {
      if (css[i + 1] == '}') {
        css = css.slice(0, i + 1) + '\n' + tabs[num - 1] + css.slice(i + 1);
        len += num;
        i += num - 1;
      } else {
        css = css.slice(0, i + 1) + '\n' + tabs[num] + css.slice(i + 1);
        len += num + 1;
        i += num;
      }
    }
  }
  return css;
};

export const addParamsToUrl = (url?: string, params?: { [key: string]: string | number }): string => {
  if (!url || url === 'undefined' || !params || !Object.keys(params).length) return url || '';

  if (!url.startsWith('https://') && !url.startsWith('http://')) {
    url = `https://${url}`;
  }

  const newUrl = new URL(url);
  let urlSearch = newUrl.search;
  const questionMarksCount = (urlSearch.match(/\?/g) || []).length;

  if (questionMarksCount > 1) {
    const firstQuestionMarkIndex = urlSearch.indexOf('?');
    const firstPart = urlSearch.slice(0, firstQuestionMarkIndex + 1);
    let remainingPart = urlSearch.slice(firstQuestionMarkIndex + 1);
    remainingPart = remainingPart.replace(/\?/g, '&');
    urlSearch = firstPart + remainingPart;
  }
  let separator = urlSearch.includes('?') ? '&' : '?';

  for (const [key, value] of Object.entries(params)) {
    const encodedKey = encodeURIComponent(key);
    const encodedValue = encodeURIComponent(value);
    const param = `${encodedKey}=${encodedValue}`;

    if (urlSearch.includes(`${key}=`)) {
      urlSearch = urlSearch.replace(new RegExp(`(${key}=)([^&]+)`), `$1${encodedValue}`);
    } else {
      urlSearch += `${separator}${param}`;
      separator = '&';
    }
  }

  newUrl.search = urlSearch;
  return newUrl.href;
};

export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const isCanPostMessageToParent = () => {
  try {
    return window.parent && window !== window.parent && typeof window.parent.postMessage === 'function';
  } catch (e) {
    return false;
  }
};

export const postMessageToParent = (message: any, targetOrigin = '*') => {
  if (isCanPostMessageToParent()) {
    retry(() => {
      window.parent.postMessage(message, targetOrigin);
    });
  }
};
